(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const cards = new Map();
  let frameId = null;

  if (reduceMotion.matches) return;

  const register = (root = document) => {
    const candidates = root.matches?.('[data-artist-showcase]')
      ? [root]
      : [...root.querySelectorAll('[data-artist-showcase]')];

    candidates.forEach((section) => {
      section.querySelectorAll('[data-artist-showcase-card]').forEach((card, index) => {
        if (cards.has(card)) return;

        cards.set(card, {
          current: 0,
          target: 0,
          depth: Number.parseFloat(card.dataset.artistSpeed || (index === 0 ? '0.55' : '0.95')),
          ease: index === 0 ? 0.075 : 0.1,
        });
      });
    });
    requestUpdate();
  };

  const update = () => {
    const viewportHeight = window.innerHeight;
    const viewportCenter = viewportHeight / 2;
    const amplitude = window.innerWidth < 750 ? 6 : 13;
    let keepAnimating = false;

    cards.forEach((state, card) => {
      if (!card.isConnected) {
        cards.delete(card);
        return;
      }

      const bounds = card.getBoundingClientRect();
      const correctedCenter = bounds.top - state.current + bounds.height / 2;
      const range = viewportCenter + bounds.height / 2;
      const progress = Math.max(-1, Math.min(1, (correctedCenter - viewportCenter) / range));

      state.target = progress * viewportHeight * (amplitude / 100) * state.depth;
      state.current += (state.target - state.current) * state.ease;

      if (Math.abs(state.target - state.current) > 0.08) keepAnimating = true;

      card.style.setProperty('--artist-showcase-y', `${state.current.toFixed(2)}px`);
    });

    frameId = keepAnimating ? window.requestAnimationFrame(update) : null;
  };

  function requestUpdate() {
    if (frameId === null) frameId = window.requestAnimationFrame(update);
  }

  register();
  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate, { passive: true });
  document.addEventListener('shopify:section:load', (event) => register(event.target));
  document.addEventListener('shopify:section:unload', requestUpdate);
})();
